import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const pipeDeteriorationStoreSelector = createSelector(
	parseNamespace,
	state => state.PipeDeteriorationStore,
);
export const selectFailureDefinitions = createSelector(
	pipeDeteriorationStoreSelector,
	state => state.failureDefinitions,
);
export const selectDeteriorationModels = createSelector(
	pipeDeteriorationStoreSelector,
	state => state.deteriorationModels,
);

export const useSelectPipeDeteriorationStore = () =>
	useSelector(pipeDeteriorationStoreSelector);
export const useSelectFailureDefinitions = () =>
	useSelector(selectFailureDefinitions);
export const useSelectDeteriorationModels = () =>
	useSelector(selectDeteriorationModels);
